export class DataFlowStream {
  public ID?: string;

  public InputModuleID: string;

  public OutputModuleID: string;

  public Title: string;
}
